import { RecordValue } from '@coveo/bueno';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { updateFacetOptions } from '../../facet-options/facet-options-actions.js';
import { facetIdDefinition } from '../generic/facet-actions-validation.js';
import { toggleExcludeFacetValue, toggleSelectFacetValue, } from './facet-set-actions.js';
import { facetValueDefinition } from './facet-set-validate-payload.js';
const definition = {
    facetId: facetIdDefinition,
    selection: new RecordValue({ values: facetValueDefinition }),
};
export const executeToggleFacetSelect = createAsyncThunk('facet/executeToggleSelect', ({ facetId, selection }, thunk) => {
    const { dispatch, extra: { validatePayload }, } = thunk;
    validatePayload({ facetId, selection }, definition);
    dispatch(toggleSelectFacetValue({ facetId, selection }));
    dispatch(updateFacetOptions());
});
export const executeToggleFacetExclude = createAsyncThunk('facet/executeToggleExclude', ({ facetId, selection }, thunk) => {
    const { dispatch, extra: { validatePayload }, } = thunk;
    validatePayload({ facetId, selection }, definition);
    dispatch(toggleExcludeFacetValue({ facetId, selection }));
    dispatch(updateFacetOptions());
});
